import React from "react";
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";

function FifteenPremier() {
  return (
        <>
    <Navbar2 />
      <div className='container-fluid px-0 pb-4 pt-5'>
        <div className="row">
            <div className="col">
              <div className='h1 text-center'>15 Premier
                <br />2025-2026 Club Roster
              </div>
            </div>
          </div>
      </div>
      <div className="container-fluid text-center">
         <div class="row justify-content-center">
          <div class="col-3">
            <div className="card mb-3">
              <div className="card-body">
                <h5 className="card-title">Sarah O'Neal</h5>
                <p className="card-text">Head Coach</p>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div className="card mb-3">
              <div className="card-body">
                <h5 className="card-title">Marina Howard</h5>
                <p className="card-text">Assistant Coach</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row text-center">
          <div className="col p-5 text-center">
            <table class="table table-striped table-bordered table-hover">
              <thead class="table-dark">
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Primary Position</th>
                  <th scope="col">Jersey #</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Ashlyn Doak</td>
                  <td>MB</td>
                  <td>1</td>
                </tr>
                <tr>
                  <td>Alia Simien</td>
                  <td>OH/DS</td>
                  <td>2</td>
                </tr>
                <tr>
                  <td>Ava Exley</td>
                  <td>OPP</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>Makayla Saidler</td>
                  <td>U</td>
                  <td>4</td>
                </tr>
                <tr>
                  <td>Viani Rodriguez</td>
                  <td>OH</td>
                  <td>5</td>
                </tr>
                <tr>
                  <td>Scarlett Lawson</td>
                  <td>MB</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td>Rishika Donthula</td>
                  <td>S</td>
                  <td>7</td>
                </tr>
                <tr>
                  <td>Madeline Hernandez</td>
                  <td>L</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>Sofia Ortiz</td>
                  <td>S</td>
                  <td>14</td>
                </tr>
                <tr>
                  <td>Alexa Brown</td>
                  <td>U</td>
                  <td>15</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default FifteenPremier;
